import { isDesktopApp } from "../../../utils/isDesktop";
import { showDesktopNotification, focusMainWindow } from "../../../utils/desktopBridge";

let ringtoneTimerId = null;
let audioContext = null;

const playRingtonePulse = () => {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) {
      return;
    }
    if (!audioContext) {
      audioContext = new AudioCtx();
    }
    if (audioContext.state === "suspended") {
      audioContext.resume().catch(() => undefined);
    }
    const oscillator = audioContext.createOscillator();
    const gain = audioContext.createGain();
    oscillator.type = "sine";
    oscillator.frequency.value = 520;
    gain.gain.value = 0.08;
    oscillator.connect(gain);
    gain.connect(audioContext.destination);
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.35);
  } catch {
    // Ringtone is best-effort; UI overlay remains primary.
  }
};

export const requestIncomingCallNotificationPermission = async () => {
  if (typeof window === "undefined" || !("Notification" in window)) {
    return false;
  }
  if (Notification.permission === "granted") {
    return true;
  }
  if (Notification.permission === "denied") {
    return false;
  }
  try {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  } catch {
    return false;
  }
};

export const showIncomingCallNotification = (caller) => {
  if (typeof window === "undefined" || !("Notification" in window)) {
    return;
  }
  if (Notification.permission !== "granted") {
    return;
  }
  try {
    new Notification("Incoming call", {
      body: caller || "Unknown caller",
      tag: "browser-phone-incoming",
      requireInteraction: true,
    });
  } catch {
    // Ignore notification failures.
  }
};

export const startIncomingCallAlert = (caller) => {
  stopIncomingCallAlert();
  playRingtonePulse();
  ringtoneTimerId = window.setInterval(playRingtonePulse, 2000);
  if (isDesktopApp()) {
    showDesktopNotification("Incoming call", caller || "Unknown caller").catch(() => undefined);
    focusMainWindow().catch(() => undefined);
    return;
  }
  showIncomingCallNotification(caller);
};

export const stopIncomingCallAlert = () => {
  if (ringtoneTimerId) {
    window.clearInterval(ringtoneTimerId);
    ringtoneTimerId = null;
  }
};
